import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { footerTaxoMessagingSelector } from 'store/selectors';
import { useAppSelector } from 'store/store';
import FooterMessaging from './FooterMessaging';

const FooterMessagingContainer = () => {
  const messaging = useAppSelector(footerTaxoMessagingSelector);

  if (!messaging) {
    return null;
  }

  return (
    <ErrorBoundaryWithLogger componentId="FooterPL-FooterMessaging">
      <FooterMessaging footerMessagingData={messaging} />
    </ErrorBoundaryWithLogger>
  );
};

export default FooterMessagingContainer;
